import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, concatMap, map } from "rxjs/operators";
import { AbstractUserService } from "src/app/interfaces";
import { Notification } from "src/app/notifications/notification";
import { NotificationActions } from "src/app/notifications/state/actions";
import { UserActions } from "./actions";

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private service: AbstractUserService
  ) {}

  loadCurrentUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadCurrentUser),
      concatMap(() =>
        this.service.getCurrentUser().pipe(
          map((user) => UserActions.loadCurrentUserSuccess({ user })),
          catchError((error) =>
            of(UserActions.loadCurrentUserFailure({ error }))
          )
        )
      )
    );
  });

  loadCurrentUserFailure$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadCurrentUserFailure),
      map(() => {
        const notification = {
          content: "loadCurrentUserFailure_message",
          level: "error"
        } as Notification;
        return NotificationActions.showNotification({ notification });
      })
    );
  });
}
